"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.pixiApp = void 0;
const pixi_js_1 = require("pixi.js");
exports.pixiApp = new pixi_js_1.Application({ width: 800, height: 600, backgroundColor: 0xffffff });
(_a = document.getElementById('canvas_wrapper')) === null || _a === void 0 ? void 0 : _a.appendChild(exports.pixiApp.view);
